export const color = {
  brand: {
    100: '#FFF1E9',
    200: '#FFDDC9',
    300: '#FFBB91',
    400: '#FF9B5E',
    500: '#FF6A10',
    600: '#EE5A00',
    700: '#BD4700',
    800: '#933600',
    900: '#5F2100',
    950: '#250A00',
  },
  neutral: {
    100: '#DFF2FF',
    200: '#B2E1FF',
    300: '#77C7FB',
    400: '#41B5FF',
    500: '#078FE7',
    600: '#0078C6',
    700: '#0065A7',
    800: '#014977',
    900: '#012B46',
    950: '#00121F',
  },
  background: {
    default: '#FFFFFF',
    secondary: '#FAFAFA',
    tertiary: '#F0F0F0',
    disabled: '#FFFFFF',
    overlay: { default: '#FFFFFF', disabled: 'rgba(235, 238, 239, .56)' },
    alert: { default: '#FFFFFF', flash: '#FFFFFF' },
    bubble: { default: '#FFFFFF' },
    button: {
      default: '#FFFFFF',
      primary: '#EE5A00',
      alternate: '#DCDCDC',
      finish: '#009F33',
      disabled: '#FFFFFF',
    },
    datepicker: { default: '#FFFFFF' },
    dropdown: { default: '#FFFFFF' },
    input: { default: '#FFFFFF', invalid: '#FBEDED' },
    modal: { default: '#FFFFFF' },
    progressbar: { track: '#F0F0F0' },
    table: {
      default: '#FFFFFF',
      header: { default: '#F0F0F0' },
      row: { zebra: { default: '#FAFAFA' } },
    },
    tile: { default: '#FFFFFF' },
    tooltip: { default: '#FFFFFF' },
    topbar: { default: '#FFFFFF', float: '#FFFFFF' },
    inverse: {
      default: '#141414',
      secondary: '#000000',
      tertiary: '#202020',
      disabled: 'rgba(0, 0, 0, 0)',
      overlay: { default: '#3A3A3A', disabled: 'rgba(1, 10, 15, .44)' },
      alert: { default: '#242424', flash: '#353535' },
      bubble: { default: '#292929' },
      button: {
        default: 'rgba(0, 0, 0, .4392)',
        primary: '#EE5A00',
        alternate: '#6C6C6C',
        finish: '#009F33',
        disabled: 'rgba(0, 0, 0, 0)',
      },
      datepicker: { default: '#292929' },
      dropdown: { default: '#292929' },
      input: { default: 'rgba(0, 0, 0, .4392)', invalid: '#290000' },
      modal: { default: '#3A3A3A' },
      progressbar: { track: 'rgba(0, 0, 0, .4392)' },
      table: {
        default: '#141414',
        header: { default: '#202020' },
        row: { zebra: { default: 'rgba(255, 255, 255, .0784)' } },
      },
      tile: { default: '#242424' },
      tooltip: { default: '#292929' },
      topbar: { default: '#242424', float: '#353535' },
      elevation: {
        100: '#242424',
        200: '#292929',
        300: '#303030',
        400: '#353535',
        500: '#373737',
        600: '#3A3A3A',
      },
    },
    elevation: {
      100: '#FFFFFF',
      200: '#FFFFFF',
      300: '#FFFFFF',
      400: '#FFFFFF',
      500: '#FFFFFF',
      600: '#FFFFFF',
    },
  },
  border: {
    default: '#DCDCDC',
    element: { secondary: 'rgba(0, 0, 0, .0588)' },
    disabled: '#DCDCDC',
    button: {
      default: '#BEBEBE',
      primary: 'rgba(0, 0, 0, .0588)',
      alternate: '#BEBEBE',
      finish: 'rgba(0, 0, 0, .0588)',
      disabled: '#DCDCDC',
    },
    input: {
      default: '#8F8F8F',
      invalid: '#CD212E',
      textfield: { hover: { default: '#202020', invalid: '#720002' } },
      focus: '#8F8F8F',
      hover: '#8F8F8F',
    },
    progressbar: { track: { default: '#8F8F8F', bottom: '#BEBEBE' } },
    table: { default: '#DCDCDC', row: { zebra: { default: '#DCDCDC' } } },
    inverse: {
      default: 'rgba(255, 255, 255, .1961)',
      element: { secondary: 'rgba(255, 255, 255, .1961)' },
      disabled: 'rgba(255, 255, 255, .2824)',
      button: {
        default: 'rgba(255, 255, 255, .8627)',
        primary: 'rgba(0, 0, 0, 0)',
        alternate: 'rgba(255, 255, 255, .2824)',
        finish: 'rgba(0, 0, 0, 0)',
        disabled: 'rgba(255, 255, 255, .2824)',
      },
      input: {
        default: 'rgba(255, 255, 255, .8627)',
        invalid: '#F1515D',
        textfield: { hover: { default: 'rgba(255, 255, 255, .9804)', invalid: '#F58E94' } },
        focus: 'rgba(255, 255, 255, .8627)',
        hover: 'rgba(255, 255, 255, .8627)',
      },
      progressbar: { track: { default: '#6C6C6C', bottom: '#BEBEBE' } },
      table: { default: '#6C6C6C', row: { zebra: { default: '#6C6C6C' } } },
      highlight: '#FF9B5E',
    },
    highlight: '#EE5A00',
  },
  palette: {
    brand: {
      100: '#FFF1E9',
      200: '#FFDDC9',
      300: '#FFBB91',
      400: '#FF9B5E',
      500: '#FF6A10',
      600: '#EE5A00',
      700: '#BD4700',
      800: '#933600',
      900: '#5F2100',
      950: '#250A00',
    },
    neutral: {
      100: '#DFF2FF',
      200: '#B2E1FF',
      300: '#77C7FB',
      400: '#41B5FF',
      500: '#078FE7',
      600: '#0078C6',
      700: '#0065A7',
      800: '#014977',
      900: '#012B46',
      950: '#00121F',
    },
    white: '#FFFFFF',
    black: '#000000',
    grey: {
      100: '#FAFAFA',
      200: '#F0F0F0',
      300: '#DCDCDC',
      400: '#BEBEBE',
      500: '#8F8F8F',
      600: '#6C6C6C',
      700: '#484848',
      800: '#323232',
      900: '#202020',
      950: '#141414',
    },
    green: {
      100: '#D2FADD',
      200: '#93F5B0',
      300: '#4FE27B',
      400: '#39C663',
      500: '#009F33',
      600: '#007F25',
      700: '#006F20',
      800: '#005118',
      900: '#00330E',
      950: '#001907',
    },
    red: {
      100: '#FBEDED',
      200: '#FCD4D6',
      300: '#FAB1B4',
      400: '#F58E94',
      500: '#F1515D',
      600: '#E5354A',
      700: '#CD212E',
      800: '#AF0E15',
      900: '#720002',
      950: '#290000',
    },
    yellow: {
      100: '#FFF7CA',
      200: '#FFF095',
      300: '#FFE54C',
      400: '#F9D531',
      500: '#EEBF0B',
      600: '#D2A70F',
      700: '#AD8504',
      800: '#846502',
      900: '#5C4601',
      950: '#322600',
    },
    overlay: {
      darken: {
        100: 'rgba(0, 0, 0, .0196)',
        200: 'rgba(0, 0, 0, .0588)',
        300: 'rgba(0, 0, 0, .1373)',
        400: 'rgba(0, 0, 0, .2549)',
        500: 'rgba(0, 0, 0, .4392)',
        600: 'rgba(0, 0, 0, .5765)',
        700: 'rgba(0, 0, 0, .7176)',
        800: 'rgba(0, 0, 0, .8039)',
        900: 'rgba(0, 0, 0, .8745)',
        950: 'rgba(0, 0, 0, .9216)',
      },
      lighten: {
        100: 'rgba(255, 255, 255, .9804)',
        200: 'rgba(255, 255, 255, .9412)',
        300: 'rgba(255, 255, 255, .8627)',
        400: 'rgba(255, 255, 255, .7451)',
        500: 'rgba(255, 255, 255, .5608)',
        600: 'rgba(255, 255, 255, .4235)',
        700: 'rgba(255, 255, 255, .2824)',
        800: 'rgba(255, 255, 255, .1961)',
        900: 'rgba(255, 255, 255, .1255)',
        950: 'rgba(255, 255, 255, .0784)',
      },
    },
  },
  icon: {
    large: '#8F8F8F',
    success: '#009F33',
    error: '#CD212E',
    neutral: '#078FE7',
    inverse: {
      large: '#FFFFFF',
      success: '#39C663',
      error: '#F1515D',
      neutral: '#41B5FF',
      default: '#FFFFFF',
      circled: '#FFFFFF',
      action: '#FF9B5E',
      negative: '#F1515D',
      notification: '#41B5FF',
      positive: '#39C663',
      warning: '#EEBF0B',
      disabled: '#8F8F8F',
      button: {
        default: '#FF9B5E',
        primary: '#FFFFFF',
        alternate: '#FFFFFF',
        finish: '#FFFFFF',
        disabled: '#8F8F8F',
      },
    },
    default: '#6C6C6C',
    circled: '#8F8F8F',
    action: '#EE5A00',
    negative: '#CD212E',
    notification: '#078FE7',
    positive: '#009F33',
    warning: '#AD8504',
    disabled: '#BEBEBE',
    button: {
      default: '#EE5A00',
      primary: '#FFFFFF',
      alternate: '#6C6C6C',
      finish: '#FFFFFF',
      disabled: '#BEBEBE',
    },
  },
  indicator: {
    success: '#009F33',
    error: '#CD212E',
    neutral: '#078FE7',
    inverse: {
      success: '#39C663',
      error: '#F1515D',
      neutral: '#41B5FF',
      default: '#FF9B5E',
      positive: '#39C663',
      negative: '#F1515D',
      notification: '#41B5FF',
      warning: '#EEBF0B',
      passive: '#8F8F8F',
    },
    default: '#EE5A00',
    positive: '#009F33',
    negative: '#CD212E',
    notification: '#078FE7',
    warning: '#D2A70F',
    passive: '#BEBEBE',
  },
  text: {
    large: '#323232',
    bold: '#484848',
    inverse: {
      large: '#FAFAFA',
      bold: '#F0F0F0',
      body: { default: '#FAFAFA' },
      label: { default: '#F0F0F0' },
      paragraph: { special: '#F0F0F0' },
      title: { default: '#F0F0F0' },
      hero: { default: '#F0F0F0' },
      font: { weight: { medium: '#F0F0F0', bold: '#F0F0F0' } },
      default: '#FAFAFA',
      secondary: '#BEBEBE',
      positive: { small: '#4FE27B', large: '#4FE27B' },
      negative: { small: '#F58E94', large: '#F58E94' },
      highlight: { small: '#FF9B5E', large: '#FF9B5E' },
      disabled: '#8F8F8F',
      placeholder: '#8F8F8F',
      link: '#F0F0F0',
      tab: { default: '#DCDCDC', selected: '#FFFFFF' },
      menu: '#FAFAFA',
      button: {
        default: '#FFFFFF',
        primary: '#FFFFFF',
        alternate: '#FFFFFF',
        finish: '#FFFFFF',
        disabled: '#8F8F8F',
      },
    },
    body: { default: '#323232' },
    label: { default: '#484848' },
    paragraph: { special: '#484848' },
    title: { default: '#484848' },
    hero: { default: '#484848' },
    font: { weight: { medium: '#484848', bold: '#484848' } },
    default: '#323232',
    secondary: '#6C6C6C',
    positive: { small: '#007F25', large: '#009F33' },
    negative: { small: '#CD212E', large: '#E5354A' },
    highlight: { small: '#BD4700', large: '#EE5A00' },
    disabled: '#8F8F8F',
    placeholder: '#8F8F8F',
    link: '#484848',
    tab: { default: '#484848', selected: '#141414' },
    menu: '#323232',
    button: {
      default: '#484848',
      primary: '#FFFFFF',
      alternate: '#484848',
      finish: '#FFFFFF',
      disabled: '#8F8F8F',
    },
  },
  divider: { default: '#DCDCDC', inverse: { default: 'rgba(255, 255, 255, .1961)' } },
  outline: {
    input: { focus: '#0065A7' },
    inverse: { input: { focus: '#41B5FF' } },
    focus: '#0065A7',
  },
  inverse: { outline: { focus: '#41B5FF' } },
};
export const elevation = {
  0: 'none',
  2: '0 0 0.2rem 0 rgba(0, 0, 0, .18), 0 0.1rem 0.2rem 0 rgba(0, 0, 0, .36)',
  4: '0 0 0.4rem 0 rgba(0, 0, 0, .16), 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .32)',
  8: '0 0 0.8rem 0 rgba(0, 0, 0, .14), 0 0.4rem 0.8rem 0 rgba(0, 0, 0, .28)',
  12: '0 0 1.2rem 0 rgba(0, 0, 0, .13), 0 0.6rem 1.2rem 0 rgba(0, 0, 0, .26)',
  16: '0 0 1.6rem 0 rgba(0, 0, 0, .12), 0 0.8rem 1.6rem 0 rgba(0, 0, 0, .24)',
  24: '0 0 2.4rem 0 rgba(0, 0, 0, .12), 0 1.2rem 2.4rem 0 rgba(0, 0, 0, .24)',
  topbar: {
    normal: '0 0 0.2rem 0 rgba(0, 0, 0, .18), 0 0.1rem 0.2rem 0 rgba(0, 0, 0, .36)',
    float: '0 0 1.2rem 0 rgba(0, 0, 0, .13), 0 0.6rem 1.2rem 0 rgba(0, 0, 0, .26)',
  },
  tile: { normal: '0 0 0.2rem 0 rgba(0, 0, 0, .18), 0 0.1rem 0.2rem 0 rgba(0, 0, 0, .36)' },
  alert: {
    default: '0 0 0.2rem 0 rgba(0, 0, 0, .18), 0 0.1rem 0.2rem 0 rgba(0, 0, 0, .36)',
    flash: '0 0 1.2rem 0 rgba(0, 0, 0, .13), 0 0.6rem 1.2rem 0 rgba(0, 0, 0, .26)',
  },
  tooltip: '0 0 0.4rem 0 rgba(0, 0, 0, .16), 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .32)',
  datepicker: '0 0 0.4rem 0 rgba(0, 0, 0, .16), 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .32)',
  dropdown: '0 0 0.4rem 0 rgba(0, 0, 0, .16), 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .32)',
  bubble: '0 0 0.4rem 0 rgba(0, 0, 0, .16), 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .32)',
  overlay: '0 0 2.4rem 0 rgba(0, 0, 0, .12), 0 1.2rem 2.4rem 0 rgba(0, 0, 0, .24)',
  modal: '0 0 2.4rem 0 rgba(0, 0, 0, .12), 0 1.2rem 2.4rem 0 rgba(0, 0, 0, .24)',
  negative: {
    2: 'inset 0 0.1rem 0.2rem 0 rgba(0, 0, 0, .36), inset 0 0 0.2rem 0 rgba(0, 0, 0, .18)',
    4: 'inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .32), inset 0 0 0.4rem 0 rgba(0, 0, 0, .16)',
    8: 'inset 0 0.4rem 0.8rem 0 rgba(0, 0, 0, .28), inset 0 0 0.8rem 0 rgba(0, 0, 0, .14)',
    12: 'inset 0 0.6rem 1.2rem 0 rgba(0, 0, 0, .26), inset 0 0 1.2rem 0 rgba(0, 0, 0, .13)',
    16: 'inset 0 0.8rem 1.6rem 0 rgba(0, 0, 0, .24), inset 0 0 1.6rem 0 rgba(0, 0, 0, .12)',
    24: 'inset 0 1.2rem 2.4rem 0 rgba(0, 0, 0, .24), inset 0 0 2.4rem 0 rgba(0, 0, 0, .12)',
  },
  filter: {
    0: 'none',
    2: 'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .18)) drop-shadow(0 0.1rem 0.2rem rgba(0, 0, 0, .36))',
    4: 'drop-shadow(0 0 0.4rem rgba(0, 0, 0, .16)) drop-shadow(0 0.2rem 0.4rem rgba(0, 0, 0, .32))',
    8: 'drop-shadow(0 0 0.8rem rgba(0, 0, 0, .14)) drop-shadow(0 0.4rem 0.8rem rgba(0, 0, 0, .28))',
    12: 'drop-shadow(0 0 1.2rem rgba(0, 0, 0, .13)) drop-shadow(0 0.6rem 1.2rem rgba(0, 0, 0, .26))',
    16: 'drop-shadow(0 0 1.6rem rgba(0, 0, 0, .12)) drop-shadow(0 0.8rem 1.6rem rgba(0, 0, 0, .24))',
    24: 'drop-shadow(0 0 2.4rem rgba(0, 0, 0, .12)) drop-shadow(0 1.2rem 2.4rem rgba(0, 0, 0, .24))',
    topbar: {
      normal:
        'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .18)) drop-shadow(0 0.1rem 0.2rem rgba(0, 0, 0, .36))',
      float:
        'drop-shadow(0 0 1.2rem rgba(0, 0, 0, .13)) drop-shadow(0 0.6rem 1.2rem rgba(0, 0, 0, .26))',
    },
    tile: {
      normal:
        'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .18)) drop-shadow(0 0.1rem 0.2rem rgba(0, 0, 0, .36))',
      hover:
        'drop-shadow(0 0 0.8rem rgba(0, 0, 0, .14)) drop-shadow(0 0.4rem 0.8rem rgba(0, 0, 0, .28))',
    },
    alert: {
      default:
        'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .18)) drop-shadow(0 0.1rem 0.2rem rgba(0, 0, 0, .36))',
      flash:
        'drop-shadow(0 0 1.2rem rgba(0, 0, 0, .13)) drop-shadow(0 0.6rem 1.2rem rgba(0, 0, 0, .26))',
    },
    tooltip:
      'drop-shadow(0 0 0.4rem rgba(0, 0, 0, .16)) drop-shadow(0 0.2rem 0.4rem rgba(0, 0, 0, .32))',
    datepicker:
      'drop-shadow(0 0 0.4rem rgba(0, 0, 0, .16)) drop-shadow(0 0.2rem 0.4rem rgba(0, 0, 0, .32))',
    dropdown:
      'drop-shadow(0 0 0.4rem rgba(0, 0, 0, .16)) drop-shadow(0 0.2rem 0.4rem rgba(0, 0, 0, .32))',
    bubble:
      'drop-shadow(0 0 0.4rem rgba(0, 0, 0, .16)) drop-shadow(0 0.2rem 0.4rem rgba(0, 0, 0, .32))',
    overlay:
      'drop-shadow(0 0 2.4rem rgba(0, 0, 0, .12)) drop-shadow(0 1.2rem 2.4rem rgba(0, 0, 0, .24))',
    modal:
      'drop-shadow(0 0 2.4rem rgba(0, 0, 0, .12)) drop-shadow(0 1.2rem 2.4rem rgba(0, 0, 0, .24))',
  },
};
export const icon = {
  indicator: {
    alert: 'icon_000545',
    error: 'icon_000540',
    info: 'icon_000550',
    success: 'icon_000210',
    critical: 'icon_000540',
    information: 'icon_000520',
    notification: 'icon_000545',
    positive: 'icon_000210',
    warning: 'icon_000530',
  },
  action: {
    add: 'icon_000190',
    addinfo: 'icon_000320',
    attachment: 'icon_000610',
    buy: 'icon_000390',
    callstart: 'icon_000650',
    callhangup: 'icon_000660',
    cancel: 'icon_000030',
    chat: 'icon_000450',
    confirm: 'icon_000210',
    copy: 'icon_000580',
    delete: 'icon_000330',
    download: 'icon_000170',
    edit: 'icon_000310',
    exchange: 'icon_002390',
    favourite: 'icon_000340',
    grid: 'icon_000810',
    help: 'icon_000520',
    hint: 'icon_000550',
    like: 'icon_000350',
    list: 'icon_000510',
    location: 'icon_000400',
    login: 'icon_000280',
    pay: 'icon_000790',
    print: 'icon_000770',
    refresh: 'icon_000120',
    reminder: 'icon_000560',
    remove: 'icon_000030',
    save: 'icon_000360',
    search: 'icon_000300',
    date: 'icon_000430',
    settings: 'icon_000380',
    share: 'icon_000370',
    show: 'icon_001910',
    hide: 'icon_001920',
    send: 'icon_001960',
    subtract: 'icon_000200',
    time: 'icon_001710',
    transfer: 'icon_000800',
    undo: 'icon_000130',
    upload: 'icon_000160',
    userchange: 'icon_000420',
  },
  control: {
    fastforward: 'icon_000260',
    microphoneon: 'icon_000690',
    microphoneoff: 'icon_000700',
    pause: 'icon_000240',
    play: 'icon_000230',
    rewind: 'icon_000270',
    stop: 'icon_000250',
    videocamon: 'icon_000710',
    videocamoff: 'icon_000720',
    volumeon: 'icon_000670',
    volumeoff: 'icon_000680',
  },
  navigation: {
    close: 'icon_000030',
    collapse: 'icon_000060',
    expand: 'icon_000070',
    enlarge: 'icon_000140',
    shrink: 'icon_000150',
    linkinternal: 'icon_000040',
    linkexternal: 'icon_000180',
    menu: 'icon_000010',
    more: 'icon_000020',
    next: 'icon_000040',
    previous: 'icon_000050',
    first: 'icon_002370',
    last: 'icon_002380',
    up: 'icon_000100',
    down: 'icon_000110',
    left: 'icon_000090',
    right: 'icon_000080',
  },
  finance: {
    etf: 'icon_001230',
    forex: 'icon_001120',
    funds: 'icon_001200',
    index: 'icon_001220',
    interest: 'icon_001210',
    markets: 'icon_001180',
    stock: 'icon_001190',
    sustainability: 'icon_001660',
    sustainabilityhigh: 'icon_001661',
    valueup: 'icon_001930',
    valuedown: 'icon_001940',
  },
  misc: {
    admin: 'icon_001470',
    airplane: 'icon_001330',
    ambulance: 'icon_001370',
    artwork: 'icon_002220',
    attachmentfailed: 'icon_000611',
    bank: 'icon_000930',
    bar: 'icon_002110',
    barchart: 'icon_001260',
    barcode: 'icon_000490',
    bicycle: 'icon_001350',
    bottle: 'icon_002240',
    bus: 'icon_001390',
    cafe: 'icon_001760',
    calculator: 'icon_000780',
    calendar: 'icon_000430',
    camera: 'icon_000600',
    career: 'icon_001480',
    cash: 'icon_001130',
    chatbot: 'icon_002400',
    checkmark: 'icon_000210',
    checkout: 'icon_001170',
    cleaning: 'icon_002000',
    coloring: 'icon_002070',
    component: 'icon_001510',
    computergame: 'icon_002180',
    cosmetics: 'icon_002340',
    couple: 'icon_002450',
    denied: 'icon_000220',
    devicedesktop: 'icon_000730',
    devicelaptop: 'icon_000740',
    devicephone: 'icon_000750',
    devicetablet: 'icon_000760',
    diagnosis: 'icon_001240',
    doctor: 'icon_001310',
    documentsingle: 'icon_000570',
    documentmultiple: 'icon_000580',
    draggable: 'icon_002420',
    electricity: 'icon_001730',
    email: 'icon_002360',
    excavator: 'icon_001840',
    eyeglasses: 'icon_001400',
    faceid: 'icon_001970',
    fastfood: 'icon_002100',
    feedback: 'icon_001700',
    fingerprint: 'icon_000460',
    finland: 'icon_001580',
    flag: 'icon_001570',
    folder: 'icon_000590',
    fuel: 'icon_002020',
    furniture: 'icon_001800',
    gift: 'icon_002150',
    group: 'icon_001430',
    homeappliance: 'icon_001850',
    horse: 'icon_001420',
    iban: 'icon_000470',
    income: 'icon_001150',
    inheritance: 'icon_002430',
    international: 'icon_000440',
    hospital: 'icon_001300',
    keycard: 'icon_000480',
    legal: 'icon_001550',
    linked: 'icon_000620',
    loanunsecured: 'icon_002440',
    lunch: 'icon_002010',
    mailclosed: 'icon_000630',
    mailopen: 'icon_000640',
    medication: 'icon_001320',
    meeting: 'icon_001450',
    money: 'icon_001110',
    moped: 'icon_001365',
    motorcycle: 'icon_001360',
    movies: 'icon_002170',
    music: 'icon_001540',
    nightclub: 'icon_002120',
    network: 'icon_001500',
    note: 'icon_001900',
    organization: 'icon_001490',
    parking: 'icon_002030',
    partnership: 'icon_001460',
    photo: 'icon_000600',
    piechart: 'icon_001270',
    piggybank: 'icon_002410',
    playfield: 'icon_002300',
    prize: 'icon_002210',
    property: 'icon_001160',
    publications: 'icon_000990',
    qrcode: 'icon_000500',
    radar: 'icon_001280',
    recycling: 'icon_001990',
    refurbishment: 'icon_001820',
    renovation: 'icon_001830',
    repair: 'icon_001810',
    research: 'icon_001530',
    responsibility: 'icon_001660',
    restaurant: 'icon_001750',
    savings: 'icon_001140',
    scissors: 'icon_002320',
    security: 'icon_000960',
    ship: 'icon_002270',
    shoppingbag: 'icon_001770',
    smileyhappy: 'icon_001590',
    smileypleased: 'icon_001600',
    smileyneutral: 'icon_001610',
    smileydisappointed: 'icon_001620',
    smileysad: 'icon_001630',
    solution: 'icon_001520',
    sports: 'icon_001950',
    taxi: 'icon_002050',
    towing: 'icon_002460',
    train: 'icon_002280',
    truck: 'icon_001380',
    videoclip: 'icon_001640',
    videoconference: 'icon_001000',
    watch: 'icon_002140',
    water: 'icon_001740',
    windshield: 'icon_002470',
  },
  business: {
    banking: 'icon_000830',
    health: 'icon_000870',
    home: 'icon_000970',
    insurances: 'icon_000850',
    investments: 'icon_000840',
    transport: 'icon_000880',
  },
  service: {
    benefits: 'icon_000900',
    corporate: 'icon_000820',
    corporatefunding: 'icon_001250',
    corporatesmall: 'icon_000980',
    creditcard: 'icon_000950',
    customerservice: 'icon_000890',
    forest: 'icon_000940',
    loans: 'icon_000910',
    opcorporatehub: 'icon_002480',
    opprivate: 'icon_000920',
    ownercustomer: 'icon_000905',
    person: 'icon_000410',
    verification: 'icon_000290',
  },
  insurance: {
    animal: 'icon_001410',
    boat: 'icon_001340',
    claim: 'icon_001100',
    farm: 'icon_001860',
    home: 'icon_000860',
    legal: 'icon_001560',
    person: 'icon_000410',
    travel: 'icon_001290',
    vehicle: 'icon_000880',
  },
  expenses: {
    amusementpark: 'icon_002230',
    carservice: 'icon_002060',
    carwash: 'icon_002040',
    childsupplies: 'icon_002080',
    children: 'icon_001680',
    clothing: 'icon_002130',
    concert: 'icon_002200',
    cosmetologist: 'icon_002330',
    culture: 'icon_001670',
    gamesofchange: 'icon_002250',
    groceries: 'icon_001780',
    health: 'icon_001300',
    hobbies: 'icon_001690',
    homeloan: 'icon_001980',
    hotel: 'icon_002290',
    housing: 'icon_000860',
    income: 'icon_001150',
    insurances: 'icon_000850',
    loans: 'icon_001870',
    other: 'icon_001880',
    pets: 'icon_001410',
    petsupplies: 'icon_002090',
    postalservices: 'icon_002160',
    recreational: 'icon_002310',
    restaurants: 'icon_001750',
    savings: 'icon_001140',
    shopping: 'icon_001770',
    streaming: 'icon_002190',
    taxes: 'icon_002350',
    travel: 'icon_001290',
    unknown: 'icon_000521',
    vehicles: 'icon_000880',
    wellbeing: 'icon_001650',
  },
};
export const circledicon = {
  business: {
    banking: 'circledicon_000010',
    health: 'circledicon_000050',
    home: 'circledicon_000150',
    insurances: 'circledicon_000030',
    investments: 'circledicon_000020',
    transport: 'circledicon_000060',
  },
  service: {
    benefits: 'circledicon_000080',
    corporate: 'circledicon_000190',
    corporatefunding: 'circledicon_000300',
    corporatesmall: 'circledicon_000160',
    creditcard: 'circledicon_000130',
    customerservice: 'circledicon_000070',
    forest: 'circledicon_000120',
    loans: 'circledicon_000090',
    opprivate: 'circledicon_000100',
    ownercustomer: 'circledicon_000085',
    person: 'circledicon_000180',
    verification: 'circledicon_000460',
  },
  insurance: {
    animal: 'circledicon_000260',
    boat: 'circledicon_000250',
    claim: 'circledicon_000210',
    farm: 'circledicon_000280',
    legal: 'circledicon_000270',
    person: 'circledicon_000180',
    home: 'circledicon_000040',
    travel: 'circledicon_000240',
    vehicle: 'circledicon_000060',
  },
  expenses: {
    children: 'circledicon_000350',
    culture: 'circledicon_000380',
    groceries: 'circledicon_000340',
    health: 'circledicon_000230',
    hobbies: 'circledicon_000400',
    housing: 'circledicon_000040',
    income: 'circledicon_000440',
    insurances: 'circledicon_000030',
    loans: 'circledicon_000310',
    other: 'circledicon_000320',
    pets: 'circledicon_000260',
    restaurants: 'circledicon_000360',
    savings: 'circledicon_000430',
    shopping: 'circledicon_000370',
    travel: 'circledicon_000450',
    unknown: 'circledicon_000420',
    vehicles: 'circledicon_000060',
    wellbeing: 'circledicon_000410',
  },
};
export const smallicon = {
  checkmark: 'smallicon_000010',
  critical: 'smallicon_000030',
  indeterminate: 'smallicon_000040',
  positive: 'smallicon_000010',
  warning: 'smallicon_000020',
};
export const logo = {
  op: {
    left: { default: 'logo_op_left_grey', inverse: 'logo_op_left_white' },
    mark: 'logo_op_mark',
    right: { default: 'logo_op_right_grey', inverse: 'logo_op_right_white' },
    home: {
      fi: {
        left: { default: 'logo_op_koti_fi_left_grey', inverse: 'logo_op_koti_fi_left_white' },
        right: { default: 'logo_op_koti_fi_right_grey', inverse: 'logo_op_koti_fi_right_white' },
      },
      sv: {
        left: { default: 'logo_op_koti_sv_left_grey', inverse: 'logo_op_koti_sv_left_white' },
        right: { default: 'logo_op_koti_sv_right_grey', inverse: 'logo_op_koti_sv_right_white' },
      },
    },
    group: {
      en: {
        left: { default: 'logo_op_ryhma_en_left_grey', inverse: 'logo_op_ryhma_en_left_white' },
        right: { default: 'logo_op_ryhma_en_right_grey', inverse: 'logo_op_ryhma_en_right_white' },
      },
      fi: {
        left: { default: 'logo_op_ryhma_fi_left_grey', inverse: 'logo_op_ryhma_fi_left_white' },
        right: { default: 'logo_op_ryhma_fi_right_grey', inverse: 'logo_op_ryhma_fi_right_white' },
      },
      sv: {
        left: { default: 'logo_op_ryhma_sv_left_grey', inverse: 'logo_op_ryhma_sv_left_white' },
        right: { default: 'logo_op_ryhma_sv_right_grey', inverse: 'logo_op_ryhma_sv_right_white' },
      },
    },
  },
  pohjola: {
    insurance: {
      en: {
        left: {
          default: 'logo_pohjola_vakuutus_en_left_grey',
          inverse: 'logo_pohjola_vakuutus_en_left_white',
        },
        right: {
          default: 'logo_pohjola_vakuutus_en_right_grey',
          inverse: 'logo_pohjola_vakuutus_en_right_white',
        },
      },
      fi: {
        left: {
          default: 'logo_pohjola_vakuutus_fi_left_grey',
          inverse: 'logo_pohjola_vakuutus_fi_left_white',
        },
        right: {
          default: 'logo_pohjola_vakuutus_fi_right_grey',
          inverse: 'logo_pohjola_vakuutus_fi_right_white',
        },
      },
      sv: {
        left: {
          default: 'logo_pohjola_vakuutus_sv_left_grey',
          inverse: 'logo_pohjola_vakuutus_sv_left_white',
        },
        right: {
          default: 'logo_pohjola_vakuutus_sv_right_grey',
          inverse: 'logo_pohjola_vakuutus_sv_right_white',
        },
      },
    },
  },
};
export const misc = {
  alpha: {
    darken: {
      100: '1.96%',
      200: '5.88%',
      300: '13.73%',
      400: '25.49%',
      500: '43.92%',
      600: '57.65%',
      700: '71.76%',
      800: '80.39%',
      900: '87.45%',
      950: '92.16%',
    },
    lighten: {
      100: '98.04%',
      200: '94.12%',
      300: '86.27%',
      400: '74.51%',
      500: '56.08%',
      600: '42.35%',
      700: '28.24%',
      800: '19.61%',
      900: '12.55%',
      950: '7.84%',
    },
    hover: { default: '4%', colored: '6%' },
    active: { default: '8%', colored: '12%' },
    inverse: {
      hover: { default: '6%', colored: '8%' },
      active: { default: '12%', colored: '16%' },
    },
  },
};
export const size = {
  hairline: '0.1rem',
  tiny: '0.2rem',
  shadow: { offset: { x: { default: '0' } }, spread: { default: '0' } },
  icon: { default: '2.4rem', small: '2rem', large: '3.2rem' },
};
export const border = {
  radius: {
    default: '0.4rem',
    small: '0.2rem',
    button: { default: '2rem', large: '2.4rem', small: '0.2rem' },
    input: {
      radio: { default: '1.2rem', large: '1.6rem' },
      slider: { track: '0.2rem', handle: '1.2rem' },
    },
  },
  width: { default: '0.1rem' },
};
export const space = {
  xxxs: '0.4rem',
  xxs: '0.8rem',
  xs: '1.2rem',
  small: '1.6rem',
  default: '2.4rem',
  large: '3.6rem',
  xl: '4.8rem',
  xxl: '7.2rem',
  xxxl: '9.6rem',
  xxxxl: '12.8rem',
  inline: {
    icon: { button: { inner: '0.8rem', outer: '-0.8rem' } },
    grid: { default: '1.2rem', xs: '0.8rem' },
  },
  inset: {
    tight: '0.8rem',
    small: '1.2rem',
    default: '1.6rem',
    large: '2.4rem',
    button: {
      compact: '0.8rem 1.6rem',
      default: '0.8rem 2.4rem',
      large: '1.2rem 2.4rem',
      hero: '1.6rem 2.4rem',
      icon: { default: '0.8rem', large: '1.2rem' },
    },
    input: {
      default: '0.8rem 1.2rem',
      large: '1.2rem 1.6rem',
      hero: '1.6rem 2.4rem',
      small: '0.4rem 0.8rem',
    },
  },
};
export const font = {
  size: {
    1: '1.3rem',
    2: '1.5rem',
    3: '1.7rem',
    4: '1.9rem',
    5: '2.2rem',
    6: '2.6rem',
    7: '3.2rem',
    8: '3.6rem',
    9: '4.6rem',
    10: '6.2rem',
    11: '8.4rem',
    12: '10.4rem',
    body: {
      xxl: '2.4rem',
      xl: '2.1rem',
      large: '1.9rem',
      medium: '1.7rem',
      small: '1.5rem',
      xs: '1.3rem',
    },
    scale: {
      50: '1.3rem',
      100: '1.5rem',
      150: '1.7rem',
      200: '1.9rem',
      250: '2.1rem',
      300: '2.4rem',
      350: '2.7rem',
      400: '3rem',
      450: '3.4rem',
      500: '3.8rem',
      550: '4.3rem',
      600: '4.9rem',
      650: '5.5rem',
      700: '6.1rem',
      750: '6.9rem',
      800: '7.8rem',
      850: '8.7rem',
      900: '9.8rem',
    },
    medium: '1.9rem',
    large: '2.2rem',
    small: '1.5rem',
    micro: '1.3rem',
    hero: {
      large: { default: '4.9rem', breakpoint: { md: '6.1rem', lg: '7.8rem', xl: '8.7rem' } },
      medium: { default: '3.4rem', breakpoint: { md: '4.3rem', lg: '4.9rem', xl: '5.5rem' } },
      small: { default: '2.7rem', breakpoint: { md: '3rem', lg: '3.4rem' } },
    },
    label: { medium: '1.7rem', small: '1.5rem', xs: '1.3rem' },
    title: {
      xxl: '2.4rem',
      xl: '2.1rem',
      large: '1.9rem',
      medium: '1.7rem',
      small: { subtle: '1.5rem', strong: '1.5rem' },
      xs: '1.3rem',
    },
    default: '1.7rem',
    paragraph: { special: '2.1rem' },
    button: { default: '1.9rem', compact: '1.3rem' },
  },
  weight: {
    body: { xs: '500' },
    thin: '100',
    light: '300',
    medium: '500',
    bold: '600',
    hero: { large: { breakpoint: { lg: '100' } } },
    label: { default: '500', xs: '600' },
    title: {
      xxl: '500',
      xl: '500',
      large: '600',
      medium: '600',
      small: { subtle: '500', strong: '600' },
      xs: '600',
    },
    default: '300',
    link: { default: '500' },
    button: { default: '500', finish: '600', primary: '600', compact: '600' },
  },
  style: { default: 'normal' },
  family: 'Chevin',
  stack: { default: 'Chevin, sans-serif' },
  platform: {
    family: 'Chevin',
    name: {
      thin: 'chevin-thin',
      default: 'chevin-light',
      medium: 'chevin-medium',
      bold: 'chevin-demibold',
    },
    stack: { default: 'Chevin, sans-serif' },
    scalefactor: '62.5%',
  },
};
export const line = {
  height: {
    1: '1.6rem',
    2: '2rem',
    3: '2.4rem',
    4: '2.8rem',
    5: '3.6rem',
    6: '4rem',
    7: '4.8rem',
    8: '6.4rem',
    9: '8.8rem',
    10: '10.8rem',
    body: {
      xxl: '3.2rem',
      xl: '2.8rem',
      large: '2.4rem',
      medium: '2.4rem',
      small: '2rem',
      xs: '1.6rem',
    },
    multiplier: '1.3',
    scale: {
      50: '1.6rem',
      100: '2rem',
      150: '2.4rem',
      200: '2.4rem',
      250: '2.8rem',
      300: '3.2rem',
      350: '3.6rem',
      400: '4rem',
      450: '4.4rem',
      500: '4.8rem',
      550: '5.6rem',
      600: '6.4rem',
      650: '7.2rem',
      700: '8rem',
      750: '8.8rem',
      800: '10rem',
      850: '11.2rem',
      900: '12.8rem',
    },
    large: '2.8rem',
    small: '2rem',
    micro: '1.6rem',
    hero: {
      large: { default: '6.4rem', breakpoint: { md: '8rem', lg: '10rem', xl: '11.2rem' } },
      medium: { default: '4.4rem', breakpoint: { md: '5.6rem', lg: '6.4rem', xl: '7.2rem' } },
      small: { default: '3.6rem', breakpoint: { md: '4rem', lg: '4.4rem' } },
    },
    label: { medium: '2.4rem', small: '2rem', xs: '1.6rem' },
    title: {
      xxl: '3.2rem',
      xl: '2.8rem',
      large: '2.4rem',
      medium: '2.4rem',
      small: { subtle: '2rem', strong: '2rem' },
      xs: '1.6rem',
    },
    default: '2.4rem',
    paragraph: { special: '2.8rem' },
    button: { default: '2.4rem', compact: '1.6rem' },
  },
};
export const letter = {
  spacing: {
    1: '-0.05rem',
    2: '-0.025rem',
    3: '0.05rem',
    default: 'normal',
    uppercase: '0.025rem',
    tight: '-0.05rem',
    semitight: '-0.025rem',
    caps: '0.05rem',
    title: { small: '0.025rem', xs: '0.025rem' },
    button: { compact: '0.025rem' },
  },
};
export const text = {
  decoration: { default: 'none', disabled: 'line-through' },
  transform: {
    default: 'none',
    title: { small: 'uppercase', xs: 'uppercase' },
    button: { compact: 'uppercase' },
  },
};
export const breakpoint = {
  xs: { min: null, max: '42.4375em' },
  sm: { min: '42.5em', max: '49.9375em' },
  md: { min: '50em', max: '74.9375em' },
  lg: { min: '75em', max: '118.6875em' },
  xl: { min: '118.75em', max: null },
};
export const width = { outline: { focus: '0.2rem', input: { focus: '0.2rem' } } };
export const style = { outline: { focus: 'solid', input: { focus: 'solid' } } };
export const outline = {
  offset: { focus: '0.2rem' },
  style: { focus: 'solid' },
  width: { focus: '0.2rem' },
};
export const shadow = {
  alert: {
    default: '0 0 0.2rem 0 rgba(0, 0, 0, .32), 0 0.2rem 0.2rem 0 rgba(0, 0, 0, .20)',
    flash: '0 0 1rem 0 rgba(0, 0, 0, .20), 0 1.2rem 1.4rem 0 rgba(0, 0, 0, .20)',
  },
  bubble: { default: '0 0 0.3rem 0 rgba(0, 0, 0, .28), 0 0.4rem 0.6rem 0 rgba(0, 0, 0, .20)' },
  dropdown: { default: '0 0 0.3rem 0 rgba(0, 0, 0, .28), 0 0.4rem 0.6rem 0 rgba(0, 0, 0, .20)' },
  modal: { default: '0 0 2rem 0 rgba(0, 0, 0, .12), 0 2.4rem 2.8rem 0 rgba(0, 0, 0, .20)' },
  overlay: { default: '0 0 2rem 0 rgba(0, 0, 0, .12), 0 2.4rem 2.8rem 0 rgba(0, 0, 0, .20)' },
  tile: { default: '0 0 0.2rem 0 rgba(0, 0, 0, .32), 0 0.2rem 0.2rem 0 rgba(0, 0, 0, .20)' },
  tooltip: { default: '0 0 0.3rem 0 rgba(0, 0, 0, .28), 0 0.4rem 0.6rem 0 rgba(0, 0, 0, .20)' },
  topbar: {
    default: '0 0 0.2rem 0 rgba(0, 0, 0, .32), 0 0.2rem 0.2rem 0 rgba(0, 0, 0, .20)',
    float: '0 0 1rem 0 rgba(0, 0, 0, .20), 0 1.2rem 1.4rem 0 rgba(0, 0, 0, .20)',
  },
  filter: {
    alert: {
      default:
        'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .32)) drop-shadow(0 0.2rem 0.2rem rgba(0, 0, 0, .20))',
      flash:
        'drop-shadow(0 0 1rem rgba(0, 0, 0, .20)) drop-shadow(0 1.2rem 1.4rem rgba(0, 0, 0, .20))',
    },
    bubble: {
      default:
        'drop-shadow(0 0 0.3rem rgba(0, 0, 0, .28)) drop-shadow(0 0.4rem 0.6rem rgba(0, 0, 0, .20))',
    },
    datepicker: {
      default:
        'drop-shadow(0 0 0.3rem rgba(0, 0, 0, .28)) drop-shadow(0 0.4rem 0.6rem rgba(0, 0, 0, .20))',
    },
    dropdown: {
      default:
        'drop-shadow(0 0 0.3rem rgba(0, 0, 0, .28)) drop-shadow(0 0.4rem 0.6rem rgba(0, 0, 0, .20))',
    },
    modal: {
      default:
        'drop-shadow(0 0 2rem rgba(0, 0, 0, .12)) drop-shadow(0 2.4rem 2.8rem rgba(0, 0, 0, .20))',
    },
    overlay: {
      default:
        'drop-shadow(0 0 2rem rgba(0, 0, 0, .12)) drop-shadow(0 2.4rem 2.8rem rgba(0, 0, 0, .20))',
    },
    tile: {
      default:
        'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .32)) drop-shadow(0 0.2rem 0.2rem rgba(0, 0, 0, .20))',
    },
    tooltip: {
      default:
        'drop-shadow(0 0 0.3rem rgba(0, 0, 0, .28)) drop-shadow(0 0.4rem 0.6rem rgba(0, 0, 0, .20))',
    },
    topbar: {
      default:
        'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .32)) drop-shadow(0 0.2rem 0.2rem rgba(0, 0, 0, .20))',
      float:
        'drop-shadow(0 0 1rem rgba(0, 0, 0, .20)) drop-shadow(0 1.2rem 1.4rem rgba(0, 0, 0, .20))',
    },
    elevation: {
      100: 'drop-shadow(0 0 0.2rem rgba(0, 0, 0, .32)) drop-shadow(0 0.2rem 0.2rem rgba(0, 0, 0, .20))',
      200: 'drop-shadow(0 0 0.3rem rgba(0, 0, 0, .28)) drop-shadow(0 0.4rem 0.6rem rgba(0, 0, 0, .20))',
      300: 'drop-shadow(0 0 0.6rem rgba(0, 0, 0, .24)) drop-shadow(0 0.8rem 1rem rgba(0, 0, 0, .20))',
      400: 'drop-shadow(0 0 1rem rgba(0, 0, 0, .20)) drop-shadow(0 1.2rem 1.4rem rgba(0, 0, 0, .20))',
      500: 'drop-shadow(0 0 1.4rem rgba(0, 0, 0, .16)) drop-shadow(0 1.6rem 1.8rem rgba(0, 0, 0, .20))',
      600: 'drop-shadow(0 0 2rem rgba(0, 0, 0, .12)) drop-shadow(0 2.4rem 2.8rem rgba(0, 0, 0, .20))',
    },
  },
  elevation: {
    100: '0 0 0.2rem 0 rgba(0, 0, 0, .32), 0 0.2rem 0.2rem 0 rgba(0, 0, 0, .20)',
    200: '0 0 0.3rem 0 rgba(0, 0, 0, .28), 0 0.4rem 0.6rem 0 rgba(0, 0, 0, .20)',
    300: '0 0 0.6rem 0 rgba(0, 0, 0, .24), 0 0.8rem 1rem 0 rgba(0, 0, 0, .20)',
    400: '0 0 1rem 0 rgba(0, 0, 0, .20), 0 1.2rem 1.4rem 0 rgba(0, 0, 0, .20)',
    500: '0 0 1.4rem 0 rgba(0, 0, 0, .16), 0 1.6rem 1.8rem 0 rgba(0, 0, 0, .20)',
    600: '0 0 2rem 0 rgba(0, 0, 0, .12), 0 2.4rem 2.8rem 0 rgba(0, 0, 0, .20)',
    negative: {
      100: 'inset 0 0 0.2rem 0 rgba(0, 0, 0, .32), inset 0 0.2rem 0.2rem 0 rgba(0, 0, 0, .20)',
      200: 'inset 0 0 0.3rem 0 rgba(0, 0, 0, .28), inset 0 0.4rem 0.6rem 0 rgba(0, 0, 0, .20)',
      300: 'inset 0 0 0.6rem 0 rgba(0, 0, 0, .24), inset 0 0.8rem 1rem 0 rgba(0, 0, 0, .20)',
      400: 'inset 0 0 1rem 0 rgba(0, 0, 0, .20), inset 0 1.2rem 1.4rem 0 rgba(0, 0, 0, .20)',
      500: 'inset 0 0 1.4rem 0 rgba(0, 0, 0, .16), inset 0 1.6rem 1.8rem 0 rgba(0, 0, 0, .20)',
      600: 'inset 0 0 2rem 0 rgba(0, 0, 0, .12), inset 0 2.4rem 2.8rem 0 rgba(0, 0, 0, .20)',
    },
  },
};
